import React from 'react';
import { Box, Radio } from '@chakra-ui/react';

interface SelectItemRadioProps {
  parentKey?: string;
  value: string;
  onClick: (event: React.ChangeEvent<HTMLElement>) => void;
  isChecked: boolean;
  dark: boolean;
}

const SelectItemRadio: React.FC<SelectItemRadioProps> = ({
  children,
  parentKey,
  onClick,
  value,
  isChecked,
  dark,
}) => (
  <Box
    px={4}
    py={1}
    borderRadius="lg"
    cursor="pointer"
    _hover={{ bg: dark ? 'gray.900' : 'gray.200' }}
  >
    <Radio
      size="md"
      colorScheme="yellow"
      borderColor={dark ? 'gray.300' : 'gray.500'}
      name={parentKey}
      cursor="pointer"
      onChange={onClick}
      value={value}
      isChecked={isChecked}
    >
      <Box cursor="pointer">{children}</Box>
    </Radio>
  </Box>
);

export default SelectItemRadio;
